<template>
  <el-dialog
    :model-value="show"
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="recaptcha-dialog"
    width="400px"
    @close="handleClose"
  >
    <template #header>
      <div class="dialog-header">
        <h3>Security Check</h3>
      </div>
    </template>

    <div class="dialog-body">
      <div id="google-recaptcha-container"></div>
    </div>
  </el-dialog>
</template>

<script>
import { useStore } from '@/store/index';
import { mapActions } from 'pinia';

export default {
  name: 'ReCaptcha',
  props: {
    action: {
      type: String,
      default: 'signup',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['success', 'expired', 'error', 'close'],
  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.renderReCaptcha();
        });
      }
    },
  },
  mounted() {
    if (this.show) {
      this.SDCaptchaCheckPopUpExp();
      this.renderReCaptcha();
    }
  },
  methods: {
    ...mapActions(useStore, ['toRegister']),
    handleClose() {
      this.$emit('close');
    },
    async onSuccess(token) {
      const { data } = await this.$api.login.reCAPTCHA({ code: token });
      if (data.verified) {
        this.SDCaptchaCheckResult(true);
        this.$emit('success', token);
      } else {
        this.SDCaptchaCheckResult(false);
        this.$emit('error');
        console.log('onError');
      }
    },
    onExpired() {
      this.$emit('expired');
      console.log('onExpired');
    },
    onError() {
      this.$emit('error');
      console.log('onError');
    },
    renderReCaptcha() {
      const runtimeConfig = useRuntimeConfig();
      // 清除之前的实例
      if (window.grecaptcha && window.grecaptcha.reset) {
        try {
          window.grecaptcha.reset();
        } catch (e) {
          // 忽略重置错误
        }
      }

      this.$nextTick(() => {
        // 确保容器存在
        const container = document.getElementById('google-recaptcha-container');
        console.log('renderReCaptcha', container);
        if (container) {
          container.innerHTML = '';
          window.grecaptcha.render('google-recaptcha-container', {
            sitekey: runtimeConfig.public.VUE_APP_RECAPTCHA_SITE_KEY,
            callback: this.onSuccess,
            action: this.action,
            'expired-callback': this.onExpired,
            'error-callback': this.onError,
          });
        }
      });
    },
    /**
     * @TrackType sensorsdata
     * @EventType CaptchaCheckPopUp_Exp
     * @EventDesc 验证码弹窗曝光
     * @EventParams {
     * }
     * @Tapd 1008875
     */
    SDCaptchaCheckPopUpExp() {
      try {
        const sdEventName = 'CaptchaCheckPopUp_Exp';
        const sdEventParams = {
          popup_type: '人机验证弹窗',
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
        // console.log(sdEventName, sdEventParams)
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * @TrackType sensorsdata
     * @EventType CaptchaCheck_ResuLt
     * @EventDesc 验证码弹窗验证结果
     * @EventParams {‘
     *  is_verify_success 是否验证成功
     * }
     * @Tapd 1008875
     */
    SDCaptchaCheckResult(is_verify_success) {
      try {
        const sdEventName = 'CaptchaCheck_Result';
        const sdEventParams = {
          is_verify_success,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
        // console.log(sdEventName, sdEventParams)
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recaptcha-dialog {
  .dialog-header {
    text-align: center;
    font-family: $f-fb;
    h3 {
      margin: 0;
      padding-top: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;
    }
  }
  .dialog-body {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    min-height: 78px;
    #google-recaptcha-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
:deep(.recaptcha-dialog) {
  .el-dialog__body {
    padding-top: 10px !important;
  }
  .el-dialog__header {
    padding: 20px 20px 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
::v-deep() {
  .el-dialog__body {
    padding-top: 10px !important;
  }
}
</style>
